module.exports = __webpack_public_path__ + "static/thepearl-3-4bea27e6c629c85671f1114d0de83ff3.jpg";